import {LessIcon} from './LessIcon';

export const HiddenIcon = LessIcon;
